/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Utility_Website_HintInputs */

const cs_blog_utility_website_hint = /** @type {(inputs: Blog_Utility_Website_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikované články se zobrazí na webu kanceláře přes veřejné blog API.`)
};

const en_blog_utility_website_hint = /** @type {(inputs: Blog_Utility_Website_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published posts appear on your agency website via the public blog API.`)
};

/**
* | output |
* | --- |
* | "Published posts appear on your agency website via the public blog API." |
*
* @param {Blog_Utility_Website_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_utility_website_hint = /** @type {((inputs?: Blog_Utility_Website_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Utility_Website_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_utility_website_hint(inputs)
	return cs_blog_utility_website_hint(inputs)
});